<template>
	<b-container fluid>
		<page-title><h2 v-if="item"><router-link :to="{ name: 'TransferTypeList' }" class="nav-link">Typy przelewów</router-link>/Edycja</h2></page-title>

		<div class="col page-element">
			<div v-if="created" class="alert alert-success" role="status">Typ przelewu {{ created['name'] }} został dodany.</div>
			<div v-if="updated" class="alert alert-success" role="status">Typ przelewu {{ updated['name'] }} został zmieniony.</div>
			<alert-loading v-if="retrieveLoading || updateLoading"></alert-loading>
			<div v-if="retrieveError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ retrieveError }}</div>
			<div v-if="updateError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ updateError }}</div>

			<TransferTypeForm v-if="item && !retrieveLoading && !updateLoading" :handle-submit="update" :values="item" :errors="violations" :initialValues="retrieved"></TransferTypeForm>
		</div>
	</b-container>
</template>

<script>
  import TransferTypeForm from './Form.vue';
  import { mapGetters } from 'vuex';

  export default {
    created () {
      this.$store.dispatch('transfertype/update/retrieve', decodeURIComponent(this.$route.params.id));
    },
    components: {
      TransferTypeForm
    },
    computed: {
      ...mapGetters({
        retrieveError: 'transfertype/update/retrieveError',
        retrieveLoading: 'transfertype/update/retrieveLoading',
        updateError: 'transfertype/update/updateError',
        updateLoading: 'transfertype/update/updateLoading',
        created: 'transfertype/create/created',
        retrieved: 'transfertype/update/retrieved',
        updated: 'transfertype/update/updated',
        violations: 'transfertype/update/violations'
      })
    },
    data: function() {
      return {
        item: {}
      }
    },
    methods: {
      update (values) {
        this.$store.dispatch('transfertype/update/update', {item: this.retrieved, values: values });
      },
      reset () {
        this.$store.dispatch('transfertype/update/reset');
        this.$store.dispatch('transfertype/create/reset');
      }
    },
    beforeDestroy() {
      this.reset();
    }
  }
</script>



// WEBPACK FOOTER //
// Update.vue?0f1eaff4